import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './Planmuestreo.module.css';
import { getRefplan, getFactor, getDispositivo, getTipobolsa, postPlanm, getRefplanall } from '../../../redux/actions';
import Swal from 'sweetalert2';
import {
    FaDatabase,
    FaBox,
    FaCogs,
    FaBalanceScale,
    FaMicroscope,
    FaHashtag,
    FaInfoCircle,
    FaTable,
    FaTimes,
    FaEye,
    FaArrowRight,
    FaClipboardList,
    FaFlask,
    FaTools,
    FaLock,
    FaShieldAlt,
    FaLayerGroup,
    FaBuilding,
    FaWeightHanging,
    FaSearch
} from 'react-icons/fa';


const CrearPlan = () => {
    const [referencia, setReferencia] = useState('');
    const [factorCarga, setFactorCarga] = useState('');
    const [dispositivoMuestra, setDispositivoMuestra] = useState('');
    const [tipoBolsa, setTipoBolsa] = useState('');
    const [masaIncremento, setMasaIncremento] = useState('');
    const [incrementoBolsa, setIncrementoBolsa] = useState('');
    const [frecuenciaCalidad, setFrecuenciaCalidad] = useState('');
    const [frecuenciaGranulo, setFrecuenciaGranulo] = useState('');
    const [mostrarOtraFrecuencia, setMostrarOtraFrecuencia] = useState(false);
    const [otraFrecuencia, setOtraFrecuencia] = useState('');
    const [tamano, setTamano] = useState('');
    const [tamanoLote, setTamanoLote] = useState('');
    const [tonTotal, setTonTotal] = useState('');
    const [errorMensaje, setErrorMensaje] = useState("");
    const [password, setPassword] = useState('');
    const [habilitarSwitch, setHabilitarSwitch] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [busquedaRef, setBusquedaRef] = useState('');
    const [mostrarResultados, setMostrarResultados] = useState(false);
    const [busquedaModal, setBusquedaModal] = useState('');
    const searchRef = React.useRef(null);


    const dispatch = useDispatch();
    const refplan = useSelector((state) => state.refplan);
    const factcarga = useSelector((state) => state.facarga);
    const disp = useSelector((state) => state.dispositivo);
    const tipbol = useSelector((state) => state.tipobolsa);
    const refplanall = useSelector((state) => state.refplanall);

    const filteredRefs = useMemo(() => {
        if (!busquedaRef.trim()) return [];
        return refplan.filter(item =>
            item.ref.toLowerCase().includes(busquedaRef.toLowerCase())
        );
    }, [busquedaRef, refplan]);

    const handleSeleccionarRef = (refItem) => {
        setReferencia(refItem.id);
        setBusquedaRef(refItem.ref);
        setMostrarResultados(false);
    };

    const filteredRefPlanAll = useMemo(() => {
        if (!refplanall) return [];

        let filtered = [...refplanall];

        filtered.sort((a, b) => {
            const refA = a.Referencium?.ref || '';
            const refB = b.Referencium?.ref || '';

            if (refA < refB) return -1;
            if (refA > refB) return 1;

            const numA = (a.num_plan || '').toString();
            const numB = (b.num_plan || '').toString();
            return numA.localeCompare(numB, undefined, { numeric: true, sensitivity: 'base' });
        });

        if (busquedaModal.trim()) {
            filtered = filtered.filter(plan =>
                plan.Referencium?.ref?.toLowerCase().includes(busquedaModal.toLowerCase())
            );
        }

        return filtered;
    }, [refplanall, busquedaModal]);

    useEffect(() => {
        dispatch(getRefplan());
        dispatch(getFactor());
        dispatch(getDispositivo());
        dispatch(getTipobolsa());
        dispatch(getRefplanall());
    }, [dispatch]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setMostrarResultados(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        const randomPassword = Math.floor(100000 + Math.random() * 900000).toString();
        setPassword(randomPassword);
    }, []);


    // Obtener datos seleccionados
    const selectedRef = refplan.find((r) => r.id === parseInt(referencia));
    const selectedFactor = factcarga.find((f) => f.id === parseInt(factorCarga));

    // Cálculos
    const {
        numVeh,
        incremento1,
        incremento2,
        incremento3,
        totalBolsas
    } = useMemo(() => {
        const tLote = parseFloat(tamanoLote) || 0;
        const factor = selectedFactor?.factor || 0;
        const numVeh = factor ? tLote / factor : 0;

        const freqCalidad = parseFloat(frecuenciaCalidad) || 0;
        const freqGranulo = parseFloat(frecuenciaGranulo) || 0;
        const freqOtra = mostrarOtraFrecuencia ? parseFloat(otraFrecuencia) || 0 : 0;

        const incremento1 = freqCalidad * numVeh;
        const incremento2 = freqGranulo * numVeh;
        const incremento3 = freqOtra * numVeh;

        const incrBolsa = parseFloat(incrementoBolsa) || 0;
        const totalBolsas = incrBolsa ? (incremento1 + incremento2 + incremento3) / incrBolsa : '';

        return {
            numVeh: isNaN(numVeh) ? '' : numVeh.toFixed(2),
            incremento1: isNaN(incremento1) ? '' : incremento1.toFixed(2),
            incremento2: isNaN(incremento2) ? '' : incremento2.toFixed(2),
            incremento3: isNaN(incremento3) ? '' : incremento3.toFixed(2),
            totalBolsas: isNaN(totalBolsas) ? '' : Math.ceil(totalBolsas)
        };
    }, [
        tamanoLote,
        selectedFactor,
        frecuenciaCalidad,
        frecuenciaGranulo,
        otraFrecuencia,
        mostrarOtraFrecuencia,
        incrementoBolsa
    ]);

    const validarCampos = () => {
        if (
            !referencia ||
            !factorCarga ||
            !dispositivoMuestra ||
            !tipoBolsa ||
            !masaIncremento ||
            !incrementoBolsa ||
            !tamano ||
            !tamanoLote ||
            !tonTotal
        ) {
            setErrorMensaje("Complete todos los parámetros requeridos antes de procesar el plan.");
            return false;
        }
        setErrorMensaje("");
        return true;
    };


    const handleCrearPlan = async () => {
        if (!validarCampos()) return;
        const plan = {
            Idref: parseInt(referencia),
            Idfactcar: parseInt(factorCarga),
            Iddispmuest: parseInt(dispositivoMuestra),
            Idtipobolsa: parseInt(tipoBolsa),
            masa_incremento: parseInt(masaIncremento),
            incremento_bolsa: parseInt(incrementoBolsa),
            tamano: tamano,
            tamano_lote: tamanoLote,
            ton_total: tonTotal,
            frecuencia_calidad: frecuenciaCalidad ? parseInt(frecuenciaCalidad) : null,
            frecuencia_granulometria: frecuenciaGranulo ? parseInt(frecuenciaGranulo) : null,
            frecuencia_1: mostrarOtraFrecuencia ? parseInt(otraFrecuencia) : null,
            frecuencia_2: null,
            habilitado: 1,
            paralelo: habilitarSwitch ? 1 : null,
            password: password
        };
        try {
            await dispatch(postPlanm(plan));
            Swal.fire({
                icon: 'success',
                title: 'Configuración Guardada',
                text: 'El plan de muestreo ha sido generado y autorizado correctamente.',
                showConfirmButton: false,
                timer: 3000,
                background: '#0a0e14',
                color: '#f0f6fc',
            });

            // Limpiar campos
            setReferencia('');
            setBusquedaRef('');
            setFactorCarga('');
            setDispositivoMuestra('');
            setTipoBolsa('');
            setMasaIncremento('');
            setIncrementoBolsa('');
            setTamano('');
            setTamanoLote('');
            setTonTotal('');
            setFrecuenciaCalidad('');
            setFrecuenciaGranulo('');
            setOtraFrecuencia('');
            setMostrarOtraFrecuencia(false);
            const nuevaPassword = Math.floor(100000 + Math.random() * 900000).toString();
            setPassword(nuevaPassword);

            dispatch(getRefplan());
            dispatch(getFactor());
            dispatch(getDispositivo());
            dispatch(getTipobolsa());
            dispatch(getRefplanall());

        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error de Procesamiento',
                text: 'No se pudo sincronizar el plan. Intente nuevamente.',
                background: '#0a0e14',
                color: '#f0f6fc',
            });
        }
    };


    return (
        <div className={styles.mainContainer}>
            <div className={styles.formContainer}>
                <div className={styles.header}>
                    <h2 className={styles.title}>Plan de Muestreo</h2>
                    <button className={styles.viewPlansBtn} onClick={() => setIsModalOpen(true)}>
                        <FaEye /> Planes de Muestreo
                    </button>
                </div>

                <div className={styles.inputGroup}>
                    <label className={styles.label}><FaDatabase /> Referencia</label>
                    <div className={styles.searchContainer} ref={searchRef}>
                        <input
                            type="text"
                            className={styles.input}
                            placeholder="Buscar en catálogo maestro..."
                            value={busquedaRef}
                            onChange={(e) => {
                                setBusquedaRef(e.target.value);
                                setMostrarResultados(true);
                            }}
                            onFocus={() => {
                                if (busquedaRef.trim()) setMostrarResultados(true);
                            }}
                        />
                        {mostrarResultados && (
                            <div className={styles.dropdownResults}>
                                {filteredRefs.length > 0 ? (
                                    filteredRefs.map((item, index) => (
                                        <div
                                            key={index}
                                            className={styles.resultItem}
                                            onClick={() => handleSeleccionarRef(item)}
                                        >
                                            {item.ref}
                                        </div>
                                    ))
                                ) : busquedaRef.trim() !== '' ? (
                                    <div className={styles.noResults}>Identificador no encontrado</div>
                                ) : null}
                            </div>
                        )}
                    </div>
                </div>

                <div className={styles.inputGroup}>
                    <label className={styles.label}><FaCogs /> Factor de Carga</label>
                    <select
                        className={styles.select}
                        value={factorCarga}
                        onChange={(e) => setFactorCarga(e.target.value)}
                    >
                        <option value="" disabled>Seleccionar escala de carga...</option>
                        <option value="">-- Seleccionar --</option>
                        {factcarga.map((item, index) => (
                            <option key={index} value={item.id}>
                                {`${item.descripcion} » ${item.factor} t`}
                            </option>
                        ))}
                    </select>
                </div>

                <div className={styles.inputGroup}>
                    <label className={styles.label}><FaMicroscope /> Dispositivo de Muestreo</label>
                    <select
                        className={styles.select}
                        value={dispositivoMuestra}
                        onChange={(e) => setDispositivoMuestra(e.target.value)}
                    >
                        <option value="" disabled>Seleccionar herramienta...</option>
                        <option value="">-- Seleccionar --</option>
                        {disp.map((item, index) => (
                            <option key={index} value={item.id}>{`${item.dispositivo} mm`}</option>
                        ))}
                    </select>
                </div>

                <div className={styles.inputGroup}>
                    <label className={styles.label}><FaBox /> Tipo de Bolsa</label>
                    <select
                        className={styles.select}
                        value={tipoBolsa}
                        onChange={(e) => setTipoBolsa(e.target.value)}
                    >
                        <option value="" disabled>Seleccionar tipo de empaque...</option>
                        <option value="">-- Seleccionar --</option>
                        {tipbol.map((item, index) => (
                            <option key={index} value={item.id}>{item.bolsa}</option>
                        ))}
                    </select>
                </div>

                <div className={styles.inputGroup}>
                    <label className={styles.label}><FaBalanceScale /> Masa de Incremento</label>
                    <input
                        type="number"
                        className={styles.input}
                        placeholder="Ej: 500"
                        value={masaIncremento}
                        onChange={(e) => setMasaIncremento(e.target.value)}
                    />
                </div>

                <div className={styles.inputGroup}>
                    <label className={styles.label}><FaHashtag /> Incremento por Bolsa</label>
                    <input
                        type="number"
                        className={styles.input}
                        placeholder="Ej: 10"
                        value={incrementoBolsa}
                        onChange={(e) => setIncrementoBolsa(e.target.value)}
                    />
                </div>

                <div className={styles.inputGroup}>
                    <label className={styles.label}><FaLayerGroup /> Tamaño Material</label>
                    <input
                        type="text"
                        className={styles.input}
                        placeholder="Ej: 10x25"
                        value={tamano}
                        onChange={(e) => setTamano(e.target.value)}
                    />
                </div>

                <div className={styles.inputGroup}>
                    <label className={styles.label}><FaHashtag /> Tamaño de Lote</label>
                    <input
                        type="text"
                        className={styles.input}
                        placeholder="Introduzca cantidad..."
                        value={tamanoLote}
                        onChange={(e) => setTamanoLote(e.target.value)}
                    />
                </div>

                <div className={styles.inputGroup}>
                    <label className={styles.label}><FaWeightHanging /> Tonelaje Total</label>
                    <input
                        type="text"
                        className={styles.input}
                        placeholder="Especifique total t..."
                        value={tonTotal}
                        onChange={(e) => setTonTotal(e.target.value)}
                    />
                </div>

                <div className={styles.inputGroup}>
                    <label className={styles.label}><FaFlask /> Frecuencia Calidad</label>
                    <input
                        type="text"
                        className={styles.input}
                        placeholder="Valor frecuencia..."
                        value={frecuenciaCalidad}
                        onChange={(e) => setFrecuenciaCalidad(e.target.value)}
                    />
                </div>

                <div className={styles.inputGroup}>
                    <label className={styles.label}><FaFlask /> Frecuencia Granulometría</label>
                    <input
                        type="text"
                        className={styles.input}
                        placeholder="Valor frecuencia..."
                        value={frecuenciaGranulo}
                        onChange={(e) => setFrecuenciaGranulo(e.target.value)}
                    />
                </div>

                <div className={styles.checkboxGroup}>
                    <input
                        type="checkbox"
                        id="freqAdicional"
                        checked={mostrarOtraFrecuencia}
                        onChange={(e) => setMostrarOtraFrecuencia(e.target.checked)}
                    />
                    <label htmlFor="freqAdicional">¿Agregar otra frecuencia?</label>
                </div>

                {mostrarOtraFrecuencia && (
                    <div className={styles.inputGroup}>
                        <label className={styles.label}><FaTools /> Otra Frecuencia</label>
                        <input
                            type="text"
                            className={styles.input}
                            placeholder="Especificar valor..."
                            value={otraFrecuencia}
                            onChange={(e) => setOtraFrecuencia(e.target.value)}
                        />
                    </div>
                )}

                <div className={`${styles.checkboxGroup}`}>
                    <input
                        type="checkbox"
                        id="parallelAnalysis"
                        checked={habilitarSwitch}
                        onChange={(e) => setHabilitarSwitch(e.target.checked)}
                    />
                    <label htmlFor="parallelAnalysis">¿Es Paralelo?</label>
                </div>

                <div className={styles.inputGroup}>
                    <label className={styles.label}><FaLock /> Contraseña</label>
                    <input
                        type="text"
                        className={styles.input}
                        style={{ background: 'rgba(0,198,255,0.1)', color: 'var(--secondary)', fontWeight: '800', border: '1px dashed var(--secondary)' }}
                        value={password}
                        disabled
                        readOnly
                    />
                </div>

                {selectedRef && (
                    <div className={styles.infoPanel}>
                        <h4><FaInfoCircle /> Datos de Referencia</h4>
                        <div className={styles.infoItem}>
                            <span className={styles.infoLabel}>Cliente</span>
                            <span className={styles.infoValue}>{selectedRef.Cliente?.nombre}</span>
                        </div>
                        <div className={styles.infoItem}>
                            <span className={styles.infoLabel}>Material</span>
                            <span className={styles.infoValue}>{selectedRef.Material?.nombre}</span>
                        </div>
                        <div className={styles.infoItem}>
                            <span className={styles.infoLabel}>Tamaño</span>
                            <span className={styles.infoValue}>{selectedRef.tamano}</span>
                        </div>
                        <div className={styles.infoItem}>
                            <span className={styles.infoLabel}>Norma</span>
                            <span className={styles.infoValue}>{selectedRef.Norma?.nombre}</span>
                        </div>
                        <div className={styles.infoItem}>
                            <span className={styles.infoLabel}>Ubicación</span>
                            <span className={styles.infoValue}>{selectedRef.Ubicacion?.nombre}</span>
                        </div>
                    </div>
                )}

                <div className={styles.summary}>
                    <div className={styles.summaryItem}>
                        <span className={styles.summaryLabel}>Vehículos Estimados</span>
                        <span className={styles.summaryValue}>{numVeh ? Math.round(numVeh) : '-'}</span>
                    </div>
                    <div className={styles.summaryItem}>
                        <span className={styles.summaryLabel}>Total Bolsas</span>
                        <span className={styles.summaryValue}>{totalBolsas || '-'}</span>
                    </div>
                    {mostrarOtraFrecuencia && (
                        <div className={styles.summaryItem}>
                            <span className={styles.summaryLabel}>Incr. Técnico</span>
                            <span className={styles.summaryValue}>{incremento3 || '0'}</span>
                        </div>
                    )}
                </div>

                {errorMensaje && <p className={styles.error}>{errorMensaje}</p>}

                <button className={styles.button} onClick={handleCrearPlan}>
                    Generar Plan de Muestreo
                </button>
            </div>

            {isModalOpen && (
                <div className={styles.modalOverlay} onClick={() => setIsModalOpen(false)}>
                    <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                        <div className={styles.modalHeader}>
                            <div className={styles.modalTitleContainer}>
                                <h3 className={styles.tableTitle}><FaTable /> Historial de Planes de Muestreo</h3>
                                <div className={styles.modalSearchBox}>
                                    <FaDatabase />
                                    <input
                                        type="text"
                                        placeholder="Buscar por referencia..."
                                        value={busquedaModal}
                                        onChange={(e) => setBusquedaModal(e.target.value)}
                                    />
                                </div>
                            </div>
                            <button className={styles.closeModalBtn} onClick={() => setIsModalOpen(false)}>
                                <FaTimes />
                            </button>
                        </div>
                        <div className={styles.tableWrapper}>
                            <table className={styles.table}>
                                <thead>
                                    <tr>
                                        <th>ID Plan</th>
                                        <th>Referencia</th>
                                        <th>Material</th>
                                        <th>Ton. Proyectadas</th>
                                        <th>Tamaño</th>
                                        <th>Masa Incr.</th>
                                        <th>Freq. Calidad</th>
                                        <th>Freq. Granul.</th>
                                        <th>Freq. Alt</th>
                                        <th>Norma / Estándar</th>
                                        <th>Socio Comercial</th>
                                        <th>Ubicación Operativa</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredRefPlanAll && filteredRefPlanAll.length > 0 ? (
                                        filteredRefPlanAll.map((plan, idx) => {
                                            const ref = plan.Referencium || {};
                                            return (
                                                <tr key={idx}>
                                                    <td style={{ fontWeight: '800', color: 'var(--secondary)' }}>
                                                        #{plan.num_plan || '-'}
                                                    </td>
                                                    <td style={{ fontWeight: '700', whiteSpace: 'nowrap' }}>
                                                        {ref.ref}
                                                    </td>
                                                    <td>{ref.Material?.nombre}</td>
                                                    <td style={{ textAlign: 'center' }}>{plan.ton_total} t</td>
                                                    <td>{plan.tamano}</td>
                                                    <td>{plan.masa_incremento}g</td>
                                                    <td>{plan.frecuencia_calidad}</td>
                                                    <td>{plan.frecuencia_granulometria}</td>
                                                    <td>{plan.frecuencia_1 || '-'}</td>
                                                    <td>{ref.Norma?.nombre}</td>
                                                    <td>{ref.Cliente?.nombre}</td>
                                                    <td>{ref.Ubicacion?.nombre} / {ref.Lugar?.nombre}</td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="12" style={{ textAlign: 'center', padding: '100px', color: 'var(--text-secondary)' }}>
                                                {busquedaModal.trim() ? 'No se encontraron registros para la búsqueda.' : 'Cargando repositorio de planes...'}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CrearPlan;
